const donationOptions = [
    {
        title: "BUY 5 BOOKS",
        amount: "$20",
        description: "You can provide anxiously awaited-for new arrivals in our school library. Jabberwocky Bookstore (Newburyport, MA) provides most of our books at cost.",
        image: "assets/img/donate/books.jpg",
        alt: "books",
        readMoreLink: "/library-development"
    },
    {
        title: "HELP BUILD CLASSROOMS ",
        amount: "$50",
        description: "This amount can help us reach our goal of completing 8 classrooms ",
        image: "assets/img/donate/clasrrom-best.jpg",
        alt: "classrooms",
        readMoreLink: "/school-sponsorships"
    },
    {
        title: "SUPPORT A TOWN CLEAN-UP",
        amount: "$75",
        description: "You can provide bags, plastic gloves, rakes, shovels and other tools for environmental awareness.",
        image: "assets/img/donate/town-cleanup.jpg",
        alt: "cleanup",
        readMoreLink: "/news"
    },
    {
        title: "DONATE A NEW OR USED IPAD/IPHONE FOR OUR ZOOM LESSONS ",
        amount: "Any",
        description: "You can donate new or used IPAD/IPHONE or laptops and computera for the students to equip themselves with the trending technological skills.",
        image: "assets/img/donate/gadgets.png",
        alt: "gadgets",
        readMoreLink: null
    },
    {
        title: "HOST A MAASAI COMING OF AGE CEREMONY—WITHOUT THE TRADITIONAL CUT ",
        amount: "$100",
        description: "You can help support an important cultural tradition—in a way that eliminates the negative aspects.",
        image: "assets/img/donate/coming-8.png",
        alt: "comingofage",
        readMoreLink: "/coming-of-age",
    },
    {
        title: "SUPPORT GIRLS' ENRICHMENT PROGRAMS",
        amount: "$250",
        description: "This amount can fund a two-day workshop for girl groups, including AIDS Awareness training, career counseling, community service projects and more.",
        image: "assets/img/donate/Intern-5.png",
        alt: "support",
        readMoreLink: null,
    },
    {
        title: "JOIN THE BEADS CIRCLE OF FRIENDS",
        amount: "$500",
        description: [
            "You can join BEADS Circle of Friends. With this donation, you will receive and a subscription to the BEADS newsletter.",
            "Your donation will help with:",
            "Curriculum Materials",
            "Teacher Training",
            "Library Development",
            "Computers",
            "Solar Lighting",
            "Photo Equipment",
            "Career Counseling",
            "Vocational Training",
            "Environmental Education",
            "Business Training",
            "and New Group Development."
          ],
        image: "assets/img/donate/friends.jpg",
        alt: "friends",
        readMoreLink: "/friends-of-beads"
    },
    {
        title: "MAJOR GIFT WISH LIST",
        amount: "$500",
        description: [ 
            "BEADS gratefully accepts donations of items from our Wish List, which we will put to good use in our programs.", 
            "If you have an item you would like to donate, please email us at beadsofkenya@aol.com or call Debby Rooney at 609.823.7701.", 
            "Or you can assist in purchasing the following;",
            "Laptop Computers for use in Kenya",
            "35mm automatic Cameras",
            "Transistor Radios and Batteries",
            "Reading Glasses",
            "Automobile for use in Kenya",
            "and Camping Supplies."
        ],
        image: "assets/img/donate/wishlist2.png",
        alt: "books"
    },
];


export default donationOptions;